import { render, staticRenderFns } from "./ReasonInputApp19.vue?vue&type=template&id=2fcbd3e4&scoped=true&"
import script from "./ReasonInputApp19.vue?vue&type=script&lang=ts&"
export * from "./ReasonInputApp19.vue?vue&type=script&lang=ts&"
import style0 from "./ReasonInputApp19.vue?vue&type=style&index=0&id=2fcbd3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcbd3e4",
  null
  
)

export default component.exports